import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { UserModel } from "../../models/user/";
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import Button from "@material-ui/core/Button";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import blue from '@material-ui/core/colors/blue';
import { DropdownModel } from '../../models/dropdownModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import MenuItem from '@material-ui/core/MenuItem';
import { Role } from '../../common/enums';
import RegionService from '../../services/regionService';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import { RegionModel } from '../../models/region/regionModel';
import UserService from '../../services/userService';


interface IProps {
  closeAddEditUserModal: any,
  saveClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentUser: UserModel,
}

interface IState {
  user: UserModel,
  validationMessage: string,
  regions: Array<DropdownModel>,
  roles: Array<DropdownModel>,
  isLoading: boolean,
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '70%'
      }
    },
  },
  palette: {
    primary: blue
  }
})

class UserAddEditDialog extends React.Component<IProps, IState> {
  snackbar: any;
  regionService = new RegionService();
  userService = new UserService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      user: props.currentUser,
      validationMessage: '',
      regions: new Array<DropdownModel>(0),
      roles: new Array<DropdownModel>(0),
      isLoading: false
    };
  }

  componentDidMount() {
    var currentUser = this.props.currentUser;

    if (!currentUser.userId) {
      currentUser.isActive = true;
      this.setState({ user: currentUser });
    }

    const regions: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const roles: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 },];
    this.setState({
      isLoading: true,
      roles: roles.concat(HelperFunctions.enumToDropdownArray(Role, true))
    });
    this.regionService.getAllActiveRegions().then(
      (data: Array<RegionModel>) => {
        let regData = new Array<DropdownModel>(0);
        data.forEach(r => regData.push({ label: r.name, value: r.id }));
        this.setState({
          isLoading: false,
          regions: regions.concat(regData)
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
      });
  }

  handleChange = (key, value) => {
    const user: UserModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  //TODO: Unite handle change into one method
  handleCheckboxChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const user: UserModel = { ...this.state.user };
    user[name] = value;
    this.setState({
      user: { ...user }
    });
  }

  isValidAddEditForm() {
    let message = '';

    const { user } = this.state;

    if (!user.name || user.name.trim() === '') {
      message += Translate('Please enter name') + '<br />';
    }

    if (!user.email || user.email.trim() === '') {
      message += Translate('Please enter email') + '<br />';
    } else {
      if (!HelperFunctions.validateEmail(user.email)) {
        message += Translate('Email address is not valid') + '<br />';
      }
    }



    if (!user.userId && !user.password) {
      message += Translate('Please enter password') + '<br />';
    }

    if (!user.userId && !user.password2) {
      message += Translate('Please repeat password') + '<br />';
    }

    if (!user.roleId) {
      message += Translate('Please select a role') + '<br />';
    }

    if (user.roleId === Role.RegionalManager || user.roleId === Role.Trader) {
      if (!user.regionId) {
        message += Translate('Please select a region') + '<br />';
      }
    }

    if (user.password && user.password2) {
      if (user.password !== user.password2) {
        message += Translate('Passwords dont match') + '<br />';
      }
    }

    this.setState({
      validationMessage: message
    });

    return message === '';
  }

  handleSaveButton = (event) => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.props.saveClick(this.state.user)
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  public render() {

    const { user, roles, regions, isLoading } = this.state;

    let header = '';

    if (!user.userId) {
      header = Translate('NewUser');
    } else {
      header = Translate('EditUser');
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
          disableBackdropClick={true}
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
          <Modal.DialogContent>
            {isLoading ? <Spinner /> : null}
            <Snackbar ref={(el) => this.snackbar = el} />
            <div>
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', marginBottom: 20 }}>
                  <div style={{ width: "50%", marginRight: 10 }}>
                    <TextField
                      autoFocus
                      name="name"
                      label={Translate("Name")}
                      type="text"
                      onChange={(e) => this.handleChange('name', e.target['value'])}
                      value={user && user.name ? user.name : ""}
                    />
                  </div>
                  <div style={{ width: "50%" }}>
                    <TextField
                      name="email"
                      type="email"
                      label={Translate("Email")}
                      onChange={(e) => this.handleChange('email', e.target['value'])}
                      value={user && user.email ? user.email : ""}
                      disabled={user.userId !== undefined}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', marginBottom: 20 }}>
                  <div style={{ width: "50%", marginRight: 10 }}>
                    <TextField
                      type="password"
                      name="password"
                      label={Translate("Password")}
                      onChange={(e) => this.handleChange('password', e.target['value'])}
                      value={user && user.password ? user.password : ""}
                    />
                  </div>
                  <div style={{ width: "50%" }}>
                    <TextField
                      type="password"
                      name="password2"
                      label={Translate("RepeatPassword")}
                      onChange={(e) => this.handleChange('password2', e.target['value'])}
                      value={user && user.password2 ? user.password2 : ""}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', marginBottom: 20 }}>
                  <div style={{ width: "50%", marginRight: 10 }}>
                    <FormControl>
                      <InputLabel htmlFor="role-label">{Translate('Role')}</InputLabel>
                      <Select
                        value={user.roleId ? user.roleId : ''}
                        onChange={(e) => this.handleChange('roleId', e.target.value)}
                        inputProps={{
                          id: 'role-label'
                        }}
                      >
                        {
                          roles.map(m => <MenuItem key={m.value + 'role'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                        }
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "50%", marginRight: 10 }}>
                    <TextField
                      name="phone"
                      label={Translate("Phone")}
                      type="text"
                      onChange={(e) => this.handleChange('phone', e.target['value'])}
                      value={user && user.phone ? user.phone : ""}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', marginBottom: 20 }}>
                  {(user.roleId === Role.RegionalManager || user.roleId === Role.Trader) && regions && regions.length > 0 ?
                    <div style={{ width: "50%" }}>
                      <FormControl>
                        <InputLabel htmlFor="region-label">{Translate('Region')}</InputLabel>
                        <Select
                          value={user.regionId ? user.regionId : ''}
                          onChange={(e) => this.handleChange('regionId', e.target.value)}
                          inputProps={{
                            id: 'region-label'
                          }}
                        >
                          {
                            regions.map(m => <MenuItem key={m.value + 'region'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                          }
                        </Select>
                      </FormControl>
                    </div>
                    : null}
                </div>
                <div style={{ display: 'flex', marginBottom: 10 }}>
                  <div style={{ width: '50%' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="isActive"
                          checked={user.isActive}
                          onChange={(e) => this.handleCheckboxChange(e)}
                          color="primary"
                        />
                      }
                      label={Translate("Active")}
                      style={{ marginLeft: -10 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                {Translate("Cancel")}
              </Button>
              <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained">
                {Translate("Save")}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog >
      </MuiThemeProvider>
    )
  }
}

export default UserAddEditDialog;